import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  enotesData: [],
  totalenotes: 0,
  isOpenModal: false,
}

export const enotesSlice = createSlice({
  name: "enotes",
  initialState,
  reducers: {
    setenotesData(state, { payload }) {
      state.enotesData = payload
    },
    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setenotesData, isOpenModal,  ModalToggle } = enotesSlice.actions;

export default enotesSlice.reducer;

export function getenotes(id) {
  return async function getenotesThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getenotes(id).then(
        (response) => {         
          dispatch(setLoading(false))
          dispatch(setenotesData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addenotes(data, id) {
  return async function addenotesThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addenotes(data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          successHandler('Added Successfully')
            dispatch(getenotes(id));
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



